import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

import Button, { IconButton } from '@dbk/ui-buttons';
import Text from '@dbk/ui-text'
import { FormGroup, Message, Label } from '@dbk/ui-forms';
import { CrossIcon } from '../../../components/common/icons';
import { DOCUPLOAD_FILE_RULES } from '../../../constants';

class UploadFileButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fileTooBig: false,
      wrongFileFormat: false
    }

    this.selectFile = this.selectFile.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.removeSelectedFile = this.removeSelectedFile.bind(this);
    this.isValidFile = this.isValidFile.bind(this);
  }

  componentWillReceiveProps(props) {
    if (props && props.missingFile) {
      this.setState({
        fileTooBig: false,
        wrongFileFormat: false,
      })
    }
  }

  selectFile() {
    this.fileUploadInput.click();
  }

  onInputChange(e) {
    if (e.target && e.target.files[0]) {
      if (this.isValidFile(e.target.files[0])) {
        this.setState({
          fileTooBig: false,
          wrongFileFormat: false
        });
        this.props.onChangeFile(e.target.files[0])
      }
    }
  }

  isValidFile(file) {
    const size = file.size; // size in bytes
    const name = file.name; // file name
    const extension = name.substr(name.length - 3);

    let returnVal = true;

    if (size > DOCUPLOAD_FILE_RULES.maxSize) {
      this.removeSelectedFile();
      this.setState({
        fileTooBig: true,
        wrongFileFormat: false
      });
      returnVal = false;
    }
    if (extension.toLowerCase() !== DOCUPLOAD_FILE_RULES.extension) {
      this.removeSelectedFile();
      this.setState({
        fileTooBig: false,
        wrongFileFormat: true
      });
      returnVal = false;
    }

    return returnVal;
  }

  removeSelectedFile() {
    this.fileUploadInput.value = '';
    if(!/safari/i.test(navigator.userAgent)){
      this.fileUploadInput.type = ''
      this.fileUploadInput.type = 'file'
    }
    this.props.onChangeFile(null);
  }

  render() {
    const {
      i18n: { messages },
      file }
      = this.props;

    return (
      <div className="docsigncenter columns large-12 margin-bottom-10">
        <FormGroup>
          <Label testID="docSignCenter-modal-container-uploadFileButton-text"> {messages['app.docsigncenter.uploadDoc.fileSelect.label']} </Label>
          <div className="upload-file-group margin-top-10">
            <input
              ref={input => this.fileUploadInput = input}
              type="file"
              style={{ display: "none" }}
              accept="pdf/*"
              onChange={this.onInputChange} />

            <div>
              <Button
                testID="docSignCenter-modal-container-uploadFileButton-button"
                tertiary
                size="large"
                onClick={this.selectFile} >
                {messages['app.docsigncenter.uploadDoc.fileSelect.input']}
              </Button>
              <Message testID="docSignCenter-modal-container-uploadFileButton-error" type="error">
                {this.state.fileTooBig && messages['app.docsigncenter.uploadDoc.fileTooBig']}
                {this.state.wrongFileFormat && messages['app.docsigncenter.uploadDoc.wrongFileFormat']}
                {this.props.missingFile && messages['app.docsigncenter.uploadDoc.noFile']}
              </Message>
            </div>

            {file &&
              <div className="uploaded-file margin-left-20">
                <Text
                  testID="docSignCenter-modal-container-uploadFileButton-fileName"
                  className="margin-left-5"
                  secondary>
                  {file.name}
                </Text>
                <IconButton
                  onClick={this.removeSelectedFile}>
                  <CrossIcon color={'#999'} height={25} width={25} />
                </IconButton>
              </div>
            }

          </div>
        </FormGroup>

      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    }
  }
})(UploadFileButton);

export { UploadFileButton };
